export default "<div class=\"row\">\r\n  <p-menubar [model]=\"items\">\r\n\r\n  </p-menubar>\r\n</div>\r\n"